import React from 'react';
import { Bomb, CheckCircle2, XCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="comprar" className="py-12 md:py-24 bg-navy-900 relative overflow-hidden" data-id="element-85">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-luminosity" data-id="element-86"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-87">
        <div className="text-center mb-8 md:mb-12" data-id="element-88">
          <div className="inline-flex items-center justify-center gap-2 md:gap-3 bg-red-600/20 text-red-400 border border-red-500/30 px-4 py-1.5 md:px-6 md:py-2 rounded-full font-bold text-base md:text-lg mb-5 md:mb-8" data-id="element-89">
            <Bomb className="w-4 h-4 md:w-5 md:h-5" data-id="element-90" />
            ESTO NO ES UN EBOOK
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-black text-white" data-id="element-91">
            Es un sistema completo.
          </h2>
        </div>

        <div className="bg-navy-950 rounded-3xl border-2 border-gold-500/50 shadow-[0_0_50px_rgba(212,168,67,0.15)] overflow-hidden" data-id="element-92">
          <div className="p-5 md:p-12 border-b border-navy-800" data-id="element-93">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 flex items-center gap-2 md:gap-3" data-id="element-94">
              <span data-id="element-95">📦</span> TODO LO QUE INCLUYE TU COMPRA
            </h3>

            <div className="bg-navy-900 rounded-xl p-4 md:p-6 border border-navy-700 mb-5 md:mb-8" data-id="element-96">
              <p className="text-red-400 font-bold mb-3 md:mb-4 flex items-center gap-2 text-sm md:text-base" data-id="element-97">
                <span className="w-2 h-2 md:w-3 md:h-3 bg-red-500 rounded-full animate-pulse" data-id="element-98"></span>
                Acceso inmediato a:
              </p>
              <ul className="space-y-3 md:space-y-4 text-base md:text-lg text-white font-medium" data-id="element-99">
                <li className="flex items-center gap-2 md:gap-3" data-id="element-100">
                  <span data-id="element-101">📘</span> Charter Command System™ (Capitán)
                </li>
                <li className="flex items-center gap-2 md:gap-3" data-id="element-102">
                  <span data-id="element-103">⚙️</span> Sistema del Ingeniero{' '}
                  <span className="text-[10px] md:text-xs bg-red-600 text-white px-2 py-0.5 md:py-1 rounded-full ml-auto" data-id="element-104">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-2 md:gap-3" data-id="element-105">
                  <span data-id="element-106">🍽️</span> Sistema del Chef{' '}
                  <span className="text-[10px] md:text-xs bg-red-600 text-white px-2 py-0.5 md:py-1 rounded-full ml-auto" data-id="element-107">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-2 md:gap-3" data-id="element-108">
                  <span data-id="element-109">🧼</span> Sistema de Azafata{' '}
                  <span className="text-[10px] md:text-xs bg-red-600 text-white px-2 py-0.5 md:py-1 rounded-full ml-auto" data-id="element-110">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-2 md:gap-3" data-id="element-111">
                  <span data-id="element-112">⚓</span> Sistema del Marinero{' '}
                  <span className="text-[10px] md:text-xs bg-red-600 text-white px-2 py-0.5 md:py-1 rounded-full ml-auto" data-id="element-113">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-2 md:gap-3" data-id="element-114">
                  <span data-id="element-115">🚀</span> Manual del Capitán Nuevo{' '}
                  <span className="text-[10px] md:text-xs bg-red-600 text-white px-2 py-0.5 md:py-1 rounded-full ml-auto" data-id="element-116">
                    GRATIS HOY
                  </span>
                </li>
              </ul>
            </div>

            <div className="grid md:grid-cols-2 gap-5 md:gap-8" data-id="element-117">
              <div data-id="element-118">
                <h4 className="flex items-center gap-2 text-white font-bold mb-3 md:mb-4 text-sm md:text-base" data-id="element-119">
                  <span data-id="element-120">🔥</span> Lo que vas a eliminar definitivamente
                </h4>
                <ul className="space-y-1.5 md:space-y-2 text-slate-400 text-sm md:text-base" data-id="element-121">
                  <li className="flex items-center gap-2" data-id="element-122">
                    <XCircle className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-123" />{' '}
                    Confusión
                  </li>
                  <li className="flex items-center gap-2" data-id="element-124">
                    <XCircle className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-125" />{' '}
                    Repeticiones constantes
                  </li>
                  <li className="flex items-center gap-2" data-id="element-126">
                    <XCircle className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-127" />{' '}
                    Tareas mal hechas
                  </li>
                  <li className="flex items-center gap-2" data-id="element-128">
                    <XCircle className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-129" />{' '}
                    Falta de coordinación
                  </li>
                  <li className="flex items-center gap-2" data-id="element-130">
                    <XCircle className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-131" />{' '}
                    Estrés innecesario
                  </li>
                </ul>
              </div>

              <div data-id="element-132">
                <h4 className="flex items-center gap-2 text-white font-bold mb-3 md:mb-4 text-sm md:text-base" data-id="element-133">
                  <span data-id="element-134">✅</span> Lo que vas a ganar
                </h4>
                <ul className="space-y-1.5 md:space-y-2 text-slate-300 text-sm md:text-base" data-id="element-135">
                  <li className="flex items-center gap-2" data-id="element-136">
                    <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-137" />{' '}
                    Orden total
                  </li>
                  <li className="flex items-center gap-2" data-id="element-138">
                    <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-139" />{' '}
                    Control real
                  </li>
                  <li className="flex items-center gap-2" data-id="element-140">
                    <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-141" />{' '}
                    Claridad en todo el equipo
                  </li>
                  <li className="flex items-center gap-2" data-id="element-142">
                    <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-143" />{' '}
                    Operación fluida
                  </li>
                  <li className="flex items-center gap-2" data-id="element-144">
                    <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-145" />{' '}
                    Liderazgo sólido
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-12 bg-gradient-to-b from-navy-950 to-navy-900 text-center" data-id="element-146">
            <div className="mb-6 md:mb-8" data-id="element-147">
              <p className="text-slate-400 text-base md:text-lg line-through mb-1 md:mb-2" data-id="element-148">
                Precio regular: $99.000
              </p>
              <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-149">
                <span className="text-4xl md:text-7xl font-heading font-black text-white" data-id="element-150">
                  $42.000
                </span>
                <span className="text-xs md:text-sm text-left text-slate-400 leading-tight" data-id="element-151">
                  Pago
                  <br data-id="element-152" />
                  Único
                </span>
              </div>
            </div>

            <CTAButton isMain={true} className="w-full md:w-auto md:px-16 md:py-6 text-lg md:text-2xl" data-id="element-153" />

            <p className="text-slate-500 text-xs md:text-sm mt-4 md:mt-6 flex items-center justify-center gap-2" data-id="element-154">
              🔒 Pago 100% seguro y encriptado
            </p>
          </div>
        </div>
      </div>
    </section>;
}